import Fruits from "./Component/Fruits";

function App() {
  return (
    <div>
      <Fruits />
    </div>
  );
}

export default App;
